// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 2.4rem;
  z-index: 100;
}

.bottom-action-bar__actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* ── Save indicator (centralise) ─────────────────────────────── */

.bottom-save-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.3rem;
  min-width: 200px;
  height: 36px;
}

.bottom-save-indicator--saving {
  color: #6b7280;
}

.bottom-save-indicator--saved {
  color: #16a34a;
  font-weight: 500;
}

.bottom-save-indicator--pending {
  color: #9ca3af;
}

.bottom-save-indicator--error {
  color: #ef4444;
  font-size: 1.6rem;
  font-weight: 500;
}

.bottom-save-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-top-color: #6b7280;
  border-radius: 50%;
  animation: bottom-save-spin 0.6s linear infinite;
  flex-shrink: 0;
}

@keyframes bottom-save-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Boutons moins arrondis dans la barre d'actions */
.bottom-action-bar .bottom-action-bar__btn {
  border-radius: 8px;
  padding: 1rem 2rem;
  font-size: 1.3rem;
}

/* Offset sidebar on desktop */
@media screen and (min-width: 768px) {
  .bottom-action-bar {
    left: 0;
  }
}

/* EPIC-14 -- PDF preview loading */
.bottom-action-bar__spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: bottombar-spin 0.6s linear infinite;
  margin-right: 0.5rem;
  vertical-align: middle;
}

@keyframes bottombar-spin {
  to {
    transform: rotate(360deg);
  }
}

.bottom-action-bar__pdf-error {
  position: fixed;
  bottom: 64px;
  left: 0;
  right: 0;
  background-color: #fef2f2;
  color: #ef4444;
  font-size: 1.2rem;
  padding: 0.6rem 2.4rem;
  text-align: center;
  border-top: 1px solid #fecaca;
  z-index: 100;
}

@media screen and (min-width: 768px) {
  .bottom-action-bar__pdf-error {
    left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/BottomActionBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE;IACE,OAAO;EACT;AACF;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE;IACE,OAAO;EACT;AACF","sourcesContent":[".bottom-action-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background-color: #ffffff;\n  border-top: 1px solid #e5e7eb;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0 2.4rem;\n  z-index: 100;\n}\n\n.bottom-action-bar__actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* ── Save indicator (centralise) ─────────────────────────────── */\n\n.bottom-save-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.3rem;\n  min-width: 200px;\n  height: 36px;\n}\n\n.bottom-save-indicator--saving {\n  color: #6b7280;\n}\n\n.bottom-save-indicator--saved {\n  color: #16a34a;\n  font-weight: 500;\n}\n\n.bottom-save-indicator--pending {\n  color: #9ca3af;\n}\n\n.bottom-save-indicator--error {\n  color: #ef4444;\n  font-size: 1.6rem;\n  font-weight: 500;\n}\n\n.bottom-save-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #d1d5db;\n  border-top-color: #6b7280;\n  border-radius: 50%;\n  animation: bottom-save-spin 0.6s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes bottom-save-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Boutons moins arrondis dans la barre d'actions */\n.bottom-action-bar .bottom-action-bar__btn {\n  border-radius: 8px;\n  padding: 1rem 2rem;\n  font-size: 1.3rem;\n}\n\n/* Offset sidebar on desktop */\n@media screen and (min-width: 768px) {\n  .bottom-action-bar {\n    left: 0;\n  }\n}\n\n/* EPIC-14 -- PDF preview loading */\n.bottom-action-bar__spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: bottombar-spin 0.6s linear infinite;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n}\n\n@keyframes bottombar-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.bottom-action-bar__pdf-error {\n  position: fixed;\n  bottom: 64px;\n  left: 0;\n  right: 0;\n  background-color: #fef2f2;\n  color: #ef4444;\n  font-size: 1.2rem;\n  padding: 0.6rem 2.4rem;\n  text-align: center;\n  border-top: 1px solid #fecaca;\n  z-index: 100;\n}\n\n@media screen and (min-width: 768px) {\n  .bottom-action-bar__pdf-error {\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
